import { sessionHandlers } from './handlers/session'

export const handlers = [...sessionHandlers]
